import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Flex from '@client/components/flex/Flex';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './steByStep.scss';

const StepByStep = () => {
  const { t } = useTranslation(['advertiser']);
  return (
    <section className={styles.stepByStep}>
      <div
        className={classNames(
          styleHelper.landingPageSectionContent,
          styles.contentContainer
        )}
      >
        <Flex flexNr={1} column className={styles.copyContainer}>
          <h4
            className={classNames(
              styleHelper.landingDefaultText,
              styles.subheader
            )}
          >
            {t('advertiser:stepByStep.label')}
          </h4>
          <h2 className={classNames(styleHelper.landingH3, styleHelper.mgt16)}>
            {t('advertiser:stepByStep.title')}
          </h2>
          <Flex className={styles.stepsContainer}>
            {t('advertiser:stepByStep.steps').map((step, index) => {
              return (
                <Step
                  key={index}
                  title={`${index + 1} ${step.title}`}
                  description={step.description}
                />
              );
            })}
          </Flex>
        </Flex>
      </div>
    </section>
  );
};

export default StepByStep;

function Step({ className, title, description }) {
  return (
    <Flex column className={classNames(styles.step, className)}>
      <h5 className={classNames(styleHelper.landingH3, styles.textTitle)}>
        {title}
      </h5>
      <p className={classNames(styleHelper.landingP3, styles.stepText)}>
        {description}
      </p>
    </Flex>
  );
}
